import { Box, Paper, Typography } from "@material-ui/core";
import React from "react";
import useStyles from "./ExpCard.styles";

type PropsType = {
  title: string;
  institution: string;
  startDate: string;
  endDate: string;
  description: string;
  onClick?: () => void
}

function ExpCard({
  title,
  institution,
  startDate,
  endDate,
  description,
  onClick,
}: PropsType){
  const classes = useStyles();

  return(
    <Paper elevation={4} className={classes.cardWrap}>
      <Box className={classes.cardHead}>
        <Typography className="cTitle">{title}</Typography>
        <Typography onClick={onClick} className="cInstitution">{institution}</Typography>
      </Box>
      <Typography className={classes.datesRange}>
        {`${startDate} - ${endDate}`}
      </Typography>
      <p className={classes.cardDescription}>
        {description}
      </p>
    </Paper>
  )
}

export default ExpCard;
